"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLinkTab = exports.AccountMenuWrapper = exports.StyledLink = exports.Nav = exports.NavWrapper = void 0;
const styles_1 = require("@mui/material/styles");
const react_router_dom_1 = require("react-router-dom");
const LinkTab_1 = __importDefault(require("@/components/LinkTab"));
exports.NavWrapper = (0, styles_1.styled)("div")(({ theme }) => {
    return {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        boxShadow: "0px 1px 2px rgba(51, 51, 51, 0.1);",
        backgroundColor: theme.palette.grayScale.white,
    };
});
exports.Nav = (0, styles_1.styled)("nav")(() => ({
    marginTop: "17px",
}));
exports.StyledLink = (0, styles_1.styled)(react_router_dom_1.Link)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: theme.palette.institutional.braskemGray,
    textDecoration: "none",
    fontWeight: 700,
    margin: theme.spacing(3),
    h6: {
        marginLeft: "24px",
    },
    userEmail: {
        fontWeight: "bold",
    },
}));
exports.AccountMenuWrapper = (0, styles_1.styled)("div")(({ theme }) => ({
    margin: theme.spacing(3),
}));
exports.StyledLinkTab = (0, styles_1.styled)(LinkTab_1.default)(() => ({
    textTransform: "none",
    fontWeight: "bold",
}));
